import appConst from '../Utilities/appConst.json';
const stepper = new Map();
stepper.set(appConst.FIRST_PAGE, -1)
    .set(appConst.TWELTH_PAGE, -1)
    .set(appConst.SECOND_PAGE, 0)
    // .set(appConst.THIRD_PAGE, 1)
    // .set(appConst.FOURTH_PAGE, 1)
    .set(appConst.FIFTH_PAGE, 1)
    .set(appConst.SIXTH_PAGE, 1)
    .set(appConst.SEVENTH_PAGE, 2)
    .set(appConst.EIGHTH_PAGE, 3)
    .set(appConst.NINTH_PAGE, 4)
    .set(appConst.TENTH_PAGE, 4)
    .set(appConst.ELEVNTH_PAGE, 5)

export const max = Math.max(...stepper.values()) + 1;
export default stepper; 
